<div class="footer-row connected">
  <app-footer-info [task]="task" [statusText]="statusText"></app-footer-info>
  <app-footer-actions [task]="task" [mode]="TaskActionsMode.Connected"></app-footer-actions>
</div>
